<template>
    <b-col xs="12" lg="12">
        <b-card>
          <b-card no-body>
          <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex[1]">
            <b-tab active @click="tabChange('projects')">
              <template slot="title">
                Projects
              </template>
                <Projects />
            </b-tab>

             <b-tab @click="tabChange('users')">
              <template slot="title">
                Users
              </template>
                <Users />
            </b-tab>

            <b-tab @click="tabChange('widgets')">
              <template slot="title">
                Widgets
              </template>
                <Widgets />
            </b-tab>

            <b-tab @click="tabChange('components')">
              <template slot="title">
                Components
              </template>
                <Components />
            </b-tab>
            <b-tab @click="tabChange('scout')">
              <template slot="title">
                Scout
              </template>
                <Scout />
            </b-tab>
            <b-tab @click="tabChange('public-api')">
              <template slot="title">
                PublicAPI
              </template>
                <PublicAPI />
            </b-tab>
          </b-tabs>
          </b-card>
        </b-card>
      </b-col>
</template>
<script>
import Projects from './content/Projects'
import Widgets from './content/Widgets'
import Components from './content/Components'
import Users from './content/Users'
import Scout from './content/Scout'
import PublicAPI from './content/PublicAPI'

export default {
    name: "Documentation",
    components: {
        Projects,
        Widgets,
        Components,
        Users,
        Scout,
        PublicAPI
    },
    data: function() {
        return {
            tabIndex: [0, 0],
            tabHash: ["#projects", "#users", "#widgets", "#components", "#scout", "#public-api"]
        }
    },
    methods: {
        tabChange(e) {
            window.location.hash = e
        }
    }
}
</script>
